import { Controller } from "@hotwired/stimulus"

// Holt KI-Vorschlaege fuer die Keyword-Liste, die der Kunde gerade bearbeitet
// (siehe app/views/keyword_lists/_ai_panel.html.slim), und uebernimmt einen
// gewaehlten Vorschlag per Klick in das Keywords-Feld.
//
// Per fetch() statt ueber formaction/eigenes <form>, weil Rails'
// per_form_csrf_tokens den im Formular eingebetteten Token an dessen
// Standard-Action (POST /keyword_lists) bindet -- ein button[formaction]
// auf einen anderen Pfad wuerde denselben Token senden und serverseitig mit
// "Can't verify CSRF token authenticity" abgelehnt. Der globale Meta-Tag-
// Token (von csrf_meta_tags) ist dagegen fuer jede Action gueltig, genau
// dafuer ist er gedacht (Rails/Turbo nutzen ihn intern fuer AJAX genauso).
export default class extends Controller {
  static targets = [ "name", "keywords", "panel", "suggestButton", "testButton" ]

  suggest(event) {
    this.run(event.currentTarget, this.suggestButtonTarget.dataset.url)
  }

  test(event) {
    this.run(event.currentTarget, this.testButtonTarget.dataset.url)
  }

  apply(event) {
    event.preventDefault()

    const keywords = event.currentTarget.dataset.keywords
    if (keywords && this.hasKeywordsTarget) {
      this.keywordsTarget.value = keywords
    }
  }

  async run(button, url) {
    const originalLabel = button.textContent
    button.disabled = true
    button.textContent = "Lädt…"

    try {
      const body = new FormData()
      body.append("keyword_list[name]", this.hasNameTarget ? this.nameTarget.value : "")
      body.append("keyword_list[keywords]", this.hasKeywordsTarget ? this.keywordsTarget.value : "")

      const countryCheckboxes = this.element.querySelectorAll('input[name="keyword_list[country_codes][]"]:checked')
      countryCheckboxes.forEach(checkbox => body.append("keyword_list[country_codes][]", checkbox.value))

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/html"
        },
        body: body
      })

      const html = await response.text()
      const parsed = new DOMParser().parseFromString(html, "text/html")
      const newPanel = parsed.getElementById("ai_suggestions_panel")

      if (newPanel && this.hasPanelTarget) {
        this.panelTarget.replaceWith(newPanel)
      }
    } finally {
      button.disabled = false
      button.textContent = originalLabel
    }
  }
}
